module.exports = __webpack_public_path__ + "img/4.2.e702d761.png";